import styled, { keyframes } from 'styled-components';
import {borderRadius22, borderRadius25, borderRadius15, borderRadius50, borderRadius30, borderRadius40, borderRadius9,borderRadius50percent, borderRadius5, borderRadius11} from '../../../global/Variables.js';


export const EditorRightActionsBar = styled.div`
  
  background:white;
  box-shadow: rgb(0 0 0 / 12%) 4px 4px 8px 2px, rgb(0 0 0 / 4%) 0px 0px 0px 3px;

  top: 50%;
  transform:translateY(-50%);
  position: fixed;
  border-radius:${borderRadius22};
  z-index: 999;
  text-align: right;
  right: 0px;
  width: 44px;
  //padding-top:30px;
  padding-bottom: 4px;
  margin-right:20px;
  height: fit-content;
    display:none;
    &.active{
        display:block;
    }
    
&.withoutf{
  transform:unset !important;
}
  svg{
    width:20px;
    height:auto;
  }
  &.thermoActive{

    transform:translate3d(0,0,0);
  }
  .thermo{
    display:none;

    &.thermoUpActive{
      display:block;
    }
  }


  &.fluoActive{

    transform:translate3d(0,0,0);
  }
  .fluo{
    display:none;

    &.fluoActive{
      display:block;
    }
  }
  button{
    background:transparent;
    border:none;
    max-width:100%;
    transition: all 0.3s ease;
    right: 4px;
    position: relative;
    border-radius: ${borderRadius22};
      
    padding-bottom: 5px;
    padding-top: 5px;
    width: 82%;
    margin-top: 4px !important;
padding-left:0;
      padding-right:0;
    svg{
      top: 2px;
      position: relative;
      color: #7f7f7f;
    }
    img{
      max-width:100%;
    }
    &:hover{
     // transform:scale(1.1);
      background: #d9d9d9;
      svg{
        color: black;
      }
    }
    &.active{

   
        color:#3D55D7;
        span,
        svg{
          color:#3D55D7;
        }
      

    }
  }
`;


export const EditorLeftActionsBarMinimal = styled.div`

  background: white;
  box-shadow: rgb(0 0 0 / 12%) 4px 4px 8px 2px, rgb(0 0 0 / 4%) 0px 0px 0px 3px;

    border-radius: ${borderRadius22};
  z-index: 99;

  right: 0px;
  width: 44px;
  overflow: hidden;
  text-align: center;
  height: fit-content;
  //padding-top:30px;

  transition: all 0.3s ease;
  //  padding-top:10px;

  top:50%;
  //margin-right:20px;
  transform: translate3d(-500px, -50%, 0);
  padding-bottom: 4px;
  &.actionsBar {
    position: absolute;
    top: 0;
    left: 0px;

    @media screen and (max-width: 991px) {
      top: -135px;
    }
    
    .mainActionButton{
      padding-left: 1px;
      transition:all 0.3s ease;
      margin-left: 4px;
      margin-right: 0;
    }
  }
//&:hover{
//  button{
//    background: rgba(0,0,0,0.15);
//  }
//}
  &:hover,
  &.opened {
    width: 44px;
      border-radius: ${borderRadius22};
    .mainActionButton{
      transition:all 0.3s ease;
        padding-left: 15px;
        margin-left: 3px;
        padding-right: 0px;

     
        img{
          left: -18px;
        }
      
    }
    button {
      width: 88%;
//      background: rgba(0,0,0,0.15);
      
      span {


        height: fit-content;
        opacity: 1;
        width: 35px;
        font-size:16px;
        left: -9px;
      }

      svg {
        margin-left: -15px;
      }
      &.body {
        span {
          left: -8px !important;
        }
      }
      &.shell {
        span {
          left: -9px;
        }
      }
      &.active{
    
          background: rgba(0,0,0,0.15);
        
      }
    }
    
 
  }

  .mainActionButton {
    transition: all 0.3s ease;
    svg {
      width: 20px;
      height: unset;
    }
    img{
      transition: all 0.3s ease;
      width: 20px;
      top: -2px;
      position: relative;
      //left: -18px;
      margin-right: -10px;
      left: -7px;

    }
    //&:hover,
    //&.active{
    //  img{
    //    left: -18px;
    //  }
    //}
  }

  &.active {
      top: 50%;
    transform: translate3d(0, -50%, 0);
  }

  &.thermoActive {

    transform: translate3d(0, 0, 0);
  }

  .thermo {
    display: none;

    &.thermoUpActive {
      display: block;
    }
  }


  &.fluoActive {

    transform: translate3d(0, 0, 0);
  }

  .fluo {
    display: none;

    &.fluoActive {
      display: block;
    }
  }

  > * {
    float: left;
  }


  &.comments {
    width: 220px;
    padding: 15px;
    display: inline-block;
    overflow: visible;
    position: absolute;
    top: 50%;
    transform: translate(-500px, -50%);
    left: 0;

    &.active {
      transform: translate(0px, -50%) !important;
    }


    .addNewComment {
      textarea {
        //  border-color: #DCE2E6;
        border: 1px solid lightgray;
        background-color: white;
        transition:all 0.3s ease;
        outline: none;
        width: 97%;
        display:inline-block;
        resize: none;
        &:hover,
        &:focus,
        &:active {
          outline: none;
          border-color: #4e4e4e;
        }
      }
      button {
        margin: 0;
        margin-top:15px;
        width: 100%;
        display: inline-block;
      
        float: left;
        border: 1px solid lightgray;

      }
    }
  }

  .commentsHeader {
    margin-bottom: 15px;
  }

  .commentsContent {
    width: 100%;
    max-width: 100%;
  }

  button {
    background: transparent;
    border: none;
    text-align: center;
    width: 82%;

    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    position: relative;
    max-height: 35px;
    display: block;
    margin: 0;
    padding: 0;
    margin-top: 4px;
      border-radius: ${borderRadius40};
    padding-top: 6px;
    padding-bottom: 5px;
    margin-left: 6px;
    margin-right: 10px;
    overflow: hidden;
    padding-left: 4px;

    span {
      width: 0;
      top: -1px;
      position: relative;
      height: 0;
      margin-left: 8px;
      transition: all 0.3s ease;
      opacity: 0;
      display: inline-block;
      color: black;

    }

    svg {
      color: #7f7f7f;
      transition: all 0.3s ease;
    }

    img {
      max-height: 100%;
      max-width: 100%;
    }

    &:hover {
      //transform:scale(1.1);
      color: white;
      background: rgba(0, 0, 0, 0.15);

      svg {
        color: black;
      }
    }

    &.active {
      color: #3D55D7;

      span,
      svg {
        color: #3D55D7;
      }
    }

  }

    &.versionIsLocked{
      display:none;
    }
`;




export const EditorTopActionsBarWindow = styled.div`

  background:white;
  box-shadow: rgb(0 0 0 / 12%) 4px 4px 8px 2px, rgb(0 0 0 / 4%) 0px 0px 0px 3px;
  z-index: 99;

  &.userMenuWindow{
    width: 235px;
    right: 20px;
    position: fixed;
    top: 75px;
   
      border-radius: ${borderRadius15};
    padding: 15px;
    transition: all 0.3s ease;
    transform: translateY(-800px);
    max-height: 400px;
    overflow: hidden;
    &.active{
      transform: translateY(0);
    }
    ul{
      list-style-type: none;
      padding: 0;
      padding-left: 0;
      transition: all 0.3s ease;
      li{
        margin-top: 0px;
          border-radius: ${borderRadius9};
        transition: all 0.3s ease;
        position:relative;

        padding: 7px;
        &.active{
          background:#c5c5c5;
        }
        svg{
          width: 22px;
          height: auto;
          top: 1px;
          position: relative;
          max-height: 18px;
          opacity: 0.7;
        }
        span{
          margin-left:10px;
          font-size:12pt;
        }
        &:hover{
          background:lightgray;
        }
        &.langSwitcher{
        border-top:1px solid lightgray;
        border-radius:0px;
        text-align: center;
            padding-top: 7px;
    margin-top: 10px;
        .bold{
        font-weight:600;
        }
        span{
font-size:10pt;
        transition:all 0.3s ease;
        }
        span:first-child{
        margin-left:0;
        }
        span:hover{
        cursor:pointer;
        font-weight:600;
        
        
       }
        }
        &.langSwitcher:hover{

       background:transparent;
        }
        
        .chevronRight{
          right: 6px;
          top: 9px;
          opacity: 0.5;
          position: absolute;
        }
      }
    }
    .userMenuHeader{
      text-align:center;
        img{
          border-radius: ${borderRadius50};
        max-width: 60px;
        margin: auto auto;
        float: none;
        position: relative;
      }
      h2{
       font-weight:600;
        padding-bottom:0;
        margin-bottom:0;
      }
      span{
        font-family: 'Nunito Sans', sans-serif !important;
        font-size: 14px;
        opacity: 0.7;
      }
      .closeButton{
        top: 6px;
        right: 15px;
        width: 20px;
        left: unset;
        position:absolute;
      }
     

        .plan{
        background: gray;
        color: white;
          border-radius: ${borderRadius5};
        padding-left: 5px;
        padding-right: 5px;
        padding-bottom: 2px;
       // margin-left: 10px;
      }
    }
    
    .userMenuContentTeams{
      position: absolute;
      top: 190px;
      width: 88%;
      height: 100%;
      transform: translateX(280px);
      transition:all 0.3s ease;
      &.teamsOpened{
        transform: translateX(0);
      }
      .spanAdjust{
        position: relative;
        top: -5px;
      }
      
      img{
        height: 25px;
          border-radius: ${borderRadius50};
        margin-top: 4px;
      }
    }


    .userMenuContent{
      transition:all 0.3s ease;
      &.teamsOpened{
        transform: translateX(-280px);
      }
    }
    
  }
    
  &.notificationWindow{
    width: 235px;
    right: 20px;
    position: fixed;
    top: 75px;
      border-radius: ${borderRadius15};
    padding: 15px;
    transition: all 0.3s ease;
    transform: translateY(-800px);
    max-height: 200px;
    overflow: hidden;
    
    &.active{
      transform: translateY(0);
      max-height: unset;
      overflow: visible;
    }
  }
  .header{
      h4{
        float: unset;
        margin: 0px;
        width: 80%;
        display: inline-block;
      }
    }
  button{
    background:transparent;
    border:none;
    max-width:100%;
    transition: all 0.3s ease;
    left: -5px;
    position: relative;
    min-height: 35px;
      border-radius: ${borderRadius22};

    padding-bottom: 5px;
    padding-top: 5px;
    svg{
      color: #7f7f7f;
    }
    img{
      max-width:100%;
    }
    &:hover{
 //     transform:scale(1.1);
      background: #d9d9d9;
      svg{
        color: black;
      }
    }
    &.active{

      background-color: rgb(0, 170, 255);
      color:white;
      svg{
        color:white;
      }
      &:hover{
        background-color: rgb(51, 187, 255);
        svg{
          color:white;
        }

      }

    }
  }
  
  

  &.leftWindowPopup{
    position: absolute;
    top: -110px;
    height: fit-content;
    //right: 70px;
    min-width: 260px;
    padding-left: 15px;
    padding-right: 15px;
    transition:all 0.3s ease;
    padding-bottom: 15px;
    padding-top: 15px;
      border-radius: ${borderRadius15};
    transform:translate3d(500px,0,0);
    opacity:0;


    h4{
      margin: 0px;
      padding: 0;
      margin-bottom: 5px !important;
      font-size: 13pt !important;
      font-weight: bold !important;
      line-height: 1 !important;
    }
    //display:none;
    &.active{
      //display:block;
      opacity:1;
      transform:translate3d(0,0,0);
    }


    ul{
      list-style-type: none;
      text-align: left;
      padding: 0;
      margin-bottom: 0;
      margin-top: 0;
   
      li{
        margin-top:10px;
        transition:all 0.3s ease;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 5px;
        padding-bottom: 5px;
          border-radius: ${borderRadius5};
        svg{
          height: 1.2em;
          margin-right: 10px;
        }
        &:hover{
          background:  rgb(230, 247, 255)
        }

      }
    }
    top: -90px;
    left: 70px;



    .closeButton{
      float: right;
      right: 0;
      left: unset;
      text-align: right;
    }
    

  }
  //

`;

export const EditorLeftActionsBarWindow = styled.div`


  background:white;
  box-shadow: rgb(0 0 0 / 12%) 4px 4px 8px 2px, rgb(0 0 0 / 4%) 0px 0px 0px 3px;
  z-index: 99;
    max-height: 100%;
overflow:visible;

    
  
    .colorsButtons{
        padding-bottom:20px;
    }





    .openingTypeList{
        list-style-type: none;
        text-align: left;
        padding: 0;
        margin-bottom: 0;
        margin-top: 0;


        li{
            margin-top: 10px;
            -webkit-transition: all 0.3s ease;
            transition: all 0.3s ease;
            padding-left: 10px;
            padding-right: 10px;
            padding-top: 5px;
            padding-bottom: 5px;
            border-radius: ${borderRadius5};

            padding-left:0 !important;
            margin-top: 0 !important;
            &:hover{
                background:transparent !important;
            }
            img{
                height:60px;
                &:hover{
                    transform:scale(1.1);
                }
            }
        }


        span{
            font-size: 16px;
            font-style: normal;
            font-weight: 300;
            line-height: normal;
            top: -4px;
            position: relative;
        }
    }
    .colorsList{
        list-style-type: none;
        text-align: left;
        padding: 0;
        margin-bottom: 0;
        margin-top: 0;

        
        li{
            margin-top: 10px;
            -webkit-transition: all 0.3s ease;
            transition: all 0.3s ease;
            padding-left: 10px;
            padding-right: 10px;
            padding-top: 5px;
            padding-bottom: 5px;
            border-radius: ${borderRadius5};
            
            padding-left:0 !important;
            margin-top: 0 !important;
            &:hover{
                background:transparent !important;
            }
        }
        button{
            width:28px !important;
            height:28px !important; 
            padding: 0 !important;
            border: thin solid lightgray !important;
            margin-left:0 !important;
         //   border: thin solid lightgray;
            max-width: 100% !important;
            margin-top: 0 !important;
            -webkit-transition: all 0.3s ease !important;
            transition: all 0.1s ease !important;
            left: 0 !important;
            position: relative !important;
            min-height: unset !important;
            border-radius: ${borderRadius22} !important;
            margin-right:10px !important;
            top:2px;
            
            &:hover{
                outline: 2px solid gray;
                outline-offset: 0px;
            }
        }
      
        span{
            font-size: 16px;
            font-style: normal;
            font-weight: 300;
            line-height: normal;
            top: -6px;
            position: relative;
        }
    }

    .openingTypeList{
        list-style-type: none;
        text-align: left;
        padding: 0;
        margin-bottom: 0;
        margin-top: 0;


        li{
            margin-top: 10px;
            -webkit-transition: all 0.3s ease;
            transition: all 0.3s ease;
            padding-left: 10px;
            padding-right: 10px;
            padding-top: 5px;
            padding-bottom: 5px;
            border-radius: ${borderRadius5};

            padding-left:0 !important;
            margin-top: 0 !important;
            &:hover{
                background:transparent !important;
            }
        }
        img{
            width:28px !important;
            height:28px !important;
            padding: 0 !important;

            margin-left:0 !important;
            //border: thin solid lightgray;
            max-width: 100% !important;
            margin-top: 0 !important;
            -webkit-transition: all 0.3s ease !important;
            transition: all 0.1s ease !important;
            left: 0 !important;
            position: relative !important;
            min-height: unset !important;
            // border-radius: ${borderRadius22} !important;
            margin-right:10px !important;
            top:2px;

            //&:hover{
            //    outline: 2px solid gray;
            //    outline-offset: 0px;
            //}
        }

        span{
            font-size: 16px;
            font-style: normal;
            font-weight: 300;
            line-height: normal;
            top: 3px;
            position: relative;
        }
    }
  .downloadAdobe{
      margin-top: 5px;
      display: block;
      width: 100%;
      height: 40px;
    svg{
        color: #3D55D7;
   
    }
      span{
          color: #3D55D7 !important;
          text-align: center !important;
          font-size: 14px !important;
          font-style: normal !important;
          font-weight: 300 !important;
          line-height: normal;
      }
    &:hover{
        cursor:pointer;
    }
  }
  &.shellOptions,
  &.tabOptions{
    max-height:190px;
  }
    &.withoutf{
      transform:unset !important;
    }
  .header{
      h4{
        float: unset;
        margin: 0px;
        width: 70%;
        display: inline-block;
        font-weight:800 !important;
        position:relative;
        top:3px;
        font-size:18px !important;
      }
    img{
      height:20px;
      margin-right:10px;
    }
    }
  input[type="file"] {
    position: absolute;
    left: 0;
    top: 0;
    height: 103%;
    min-height: 52px;
    display: inline-block;
    width: 100%;
    opacity: 0;
  }
  button{
    background:transparent;
    border:none;
    max-width:100%;
    transition: all 0.3s ease;
    left: -5px;
    position: relative;
    min-height: 35px;
      border-radius: ${borderRadius22};

    padding-bottom: 5px;
    padding-top: 5px;
    svg{
      color: #7f7f7f;
    }
    img{
      max-width:100%;
    }
    &:hover{
    //  transform:scale(1.1);
      background: #d9d9d9;
      svg{
        color: black;
      }
    }
    &.active{

      background-color: rgb(0, 170, 255);
      color:white;
      svg{
        color:white;
      }
      &:hover{
        background-color: rgb(51, 187, 255);
        svg{
          color:white;
        }

      }

    }
  }
  
  
    .optionsBox{
        transform:translateX(-300px); 
        transition:all 0.3s ease;
        &.active{
                transform:translateX(0); 
        }
      h5{
          //font-size: 18px !important;
          //font-weight: 400 !important;
          margin-top: 20px;
          margin-bottom: 12px !important;
          padding-bottom: 0 !important;
          -webkit-font-smoothing: antialiased;

color:4#C4C4C;
          /* Editor/Section */
          font-family: "Nunito Sans";
          font-size: 20px !important;
          font-style: normal;
          font-weight: 400 !important;
          line-height: normal !important;
          
        
      }
        span{
            font-family: 'Nunito Sans', sans-serif !important;
            font-weight: 300;
            margin-top:10px;
            color: rgba(0,0,0,0.6);
            display: inline-block;
            margin-top: 10px;
            font-size: 16px;
            font-style: normal;
            line-height: normal;
            
        }
        input{
            margin-left: 8px;
            top: 3px;
            position: relative;
            height: 16px;
            width: 16px;
            margin-right: 4px;
        }
    
    .bubbleStatus{
        font-size: 10px;
        font-style: normal;
        font-weight: 300;
        line-height: normal;
        float: right;
        margin-top: 15px;
        margin-right: 10px;
        
        svg{
            margin-right: 4px;
            margin-top: -2px;
       
            
        }
    }
    }
    .shellsOptions{
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    
     transform:translateX(300px); 
        transition:all 0.3s ease;
        &.active{
                transform:translateX(0); 
        }
   

    }
    

    .selectProductInside{
        transition: all 0.3s ease;
        &:hover,
        &.active{
            color:blueviolet;
        }
    }
    
  .optionsButtons{
    padding-top: 0;
    margin-top: -10px;
    .fileUploader{
   //   margin-top: 45px  !important;
      margin-bottom:20px;
      
      label{
        height: 70px;
      }
    }
    button{
      //max-height: 30px;
      display: inline-block;
      width: 105px;
      //height: 115px;
      transition: all 0.3s ease;
      //border:1px solid lightgray;
      float:left;
      border-radius:0;
     background: transparent;

      left:unset !important;

      height: 115px;
      margin-top:15px;
    
    padding:0;

      border:1px solid lightgray;
  span{
    font-size:12px;
  }
      img{
        height: 65%;
        width: 65%;
        //transform: translate(10px,-10px);
        //border:thin solid lightgray;
      }
      h5{
        margin-top: 10px;
      }
      &.activeButton,
      &:hover{
        background: transparent;
       //border:2px solid #3737ff;
        border:1px solid midnightblue;
      }
      &:nth-child(2){
        margin-left: 15px;
      }
    }
    
       &.colors{
       button{
           width:30px;
           height:30px;
           border-radius: ${borderRadius50percent};
           margin-left:5px !important;
           min-height:30px !important;
           
       
        }
       
        }
  }

  .colorPickerScene{
    padding-top:5px;
    padding-bottom:5px;
    img{
      display:none !important;

    }
    span{
      display:none !important;
    }
    .actionButtonHolder{
      max-width:unset !important;
      width:15% !important;
      height:37px !important;
      overflow: visible !important;
      float:left;
      span{
        font-size:14px;
      }
    }
    button{
      background: black ;
        border-radius: ${borderRadius22};
      width: 68% ;
      height: 100% ;
      margin: auto auto;
      float: none;
      position: relative;
      left: 50%;
      transform: translateX(-50%)  !important;
      transition:all 0.1s ease;

      &.activeButton,
      &:hover{
        transform: translateX(-50%)  !important;
        border: 4px solid #00aaff;
      }
    }
  }

    .packageActionsIcons{
      margin-right: 5px;
      margin-left: 5px;
        border-radius: ${borderRadius30};
      padding-left: 2px;
      padding-right: 2px;
      padding-top: 3px;
      padding-bottom: 3px;
      margin-bottom: 10px;
      button{
        width: 33%;
        left: 0;
          border-radius: ${borderRadius40};
        font-weight:bold;
        font-size: 15px;
        img{
          height:100%;
          width:fit-content;
          max-height: 35px;
        }
      }

      .mainActionButton{
        &.active{
          box-shadow: rgb(0 0 0 / 5%) 0px 0px 3px 1px, rgb(0 0 0 / 4%) 0px 0px 0px 0px;
          background:white;
          color:black;
        }
        &:hover{
          transform:scale(1);
        }
      }
    }
  .packageActionsIconsSecondLevel{
    padding-bottom: 15px;
    //button{
    //  max-width:50px;
    //}
    span{
      color:black;      
    }


      .hiddenTop{
        display:none;
      }
      .activeLeftAlign{
        display:block;
      }
    
    .actionMenuSecondWrapper{
      text-align: left;
      padding-top: 8px;
      padding-bottom: 8px;
      //padding-left: 15px;
      border-bottom: 1px solid lightgray;
      max-width: 90%;
      margin: auto auto;
      
      .secondButton{
        width: 100%;
          border-radius: ${borderRadius5};
        left: 0;
        padding-top: 10px;
        .secondButtonImage{
          width:16%;
        }
        .secondButtonName{
          width:80%;
          text-align: left;
        }
        >div{
          float:left;
        }
        &:hover{

          background-color: rgb(183 183 183);
          color:black;
          transform:unset;
          span{
            color:black;
          }
          //img{
          //  filter:invert(1);
          //}
        
        }
        &.active{
          background-color: rgb(183 183 183);
          color:black;
          transform:unset;
          span{
            color:black;
          }
        }
        
      }
      img{
        max-height: 20px;
        margin-right:10px;
        //display: block;
        //margin: auto auto;
        //
      }
      span{
        font-weight: bold;
        font-size: 14px;
        -webkit-font-smoothing: antialiased;
      }
    }
.actionMenuThirdWrapper{
  height: fit-content;
  display: block;
  overflow: auto;
  padding-top: 15px;
  &.active{

  }
  &.hiddenDown{
    display:none;
  }
  button:hover{
    background:#c5c5c5;
  }
    .activeButton{
      background:#c5c5c5;
    }
  .actionButtonHolder{
    max-width: 29%;
    overflow: hidden;
    float: left;
    padding: 5px;
    button{
      left:0;
        border-radius: ${borderRadius5};
      &:hover{
        transform:unset;
      }
      text-align:center;
      img{
        display: block;
        max-height: 35px;
        width: auto;
        margin-bottom: 10px;
        margin: auto auto;
        margin-bottom: 10px;
      
      }
    }
  }
    &.color_picker{
      img{
        display:none !important;
       
      }
      span{
        display:none !important;
      }
      .actionButtonHolder{
        max-width:unset !important;
        width:15% !important;
        height:30px !important;
      }
      button{
          border-radius: ${borderRadius22};
        width: 68%;
        height: 24px;
        min-height: unset;
        margin: auto auto;
        float: none;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        transition:all 0.1s ease;
        border: 4px solid transparent;
        &.activeButton,
        &:hover{
          transform: translateX(-50%);
          border: 4px solid #00aaff;
        }
      }
    }
  
}

  }
  &.leftWindowPopup{
   

      position: fixed;             /* Fixujeme pozici, aby byl sidebar konzistentní */
      top: 50%;                    /* Vertikálně umístíme uprostřed */
      left: 70px;                  /* Odstup zleva */
      transform: translateX(-100%) translateY(-50%); /* Výchozí pozice mimo obrazovku vlevo */
      opacity: 0;                  /* Neviditelný, dokud aktivní stav není zapnutý */
      padding: 15px;
      min-width: 274px;
      background: #fff;            /* Barva pozadí – upravte dle potřeby */
      border-radius: 15px;
      transition: all 0.3s ease;
      height: auto;                /* Výška dle obsahu */
      max-height: 90vh;            /* Max. výška je 90 % výšky viewportu */
     // overflow-y: auto;
      overflow-y: visible !important;
      @media(max-height:700px){
          overflow-y: scroll !important;
      }
      .closeButton{
      height: 30px !important;
      top: -7px !important;
      width:30px;
        
      min-height: unset !important;

        svg{
            color:#4C4C4C;
            color: #4C4C4C;
            height: 19px;
            left: 50%;
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
            
            path{
                fill:#4C4C4C;
            }
        }
      &:hover{
        background:lightgray !important;
      }
    }

    .header{
      z-index:9;
        right: 10px;
     // position: relative;
   //   border-bottom: 1px solid lightgray;
      padding-bottom: 10px;
      margin-bottom: 15px;
        position:absolute;
      h4{
        margin: 0 !important;
      }
    }
    
     //   overflow: visible;
    &.active{
      //display:block;
      opacity:1;
      transform: translate3d(0,-50%,0);

      @media screen and (max-width: 991px) {
          transform: translate3d(0,-50%,0);
          left:60px;
      }
      
    }


    ul{
      list-style-type: none;
      text-align: left;
      padding: 0;
      margin-bottom: 0;
      margin-top: 0;
   
      li{
        margin-top:10px;
        transition:all 0.3s ease;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 5px;
        padding-bottom: 5px;
          border-radius: ${borderRadius5};
        svg{
          height: 1.2em;
          margin-right: 10px;
        }
        &:hover{
          background:  rgb(230, 247, 255)
        }

      }
    }
     top: 50%;
      left: 70px;
      

    .closeButton{
      float: right;
      right: 0;
      left: unset;
      text-align: right;
    }
      

    @media screen and (max-width: 991px) {
      min-width: 223px;
      left:0;
    }
    
  }
  //
 &.versionIsLocked{
  display:none;
}



    .mapPopupUpload{
        display:none;
        width: 238px;
        height: 108px;
        background: white;
        border-radius: ${borderRadius15};
        box-shadow: 0px 3px 10px 1px rgba(0,0,0,0.15);
        z-index: 9;

        margin-top: 2px;
        position: absolute;
        padding: 4px;
        left: 51px;

        &.inDetail{
            height: 206px;
        }
        &.active{
            display:block;
        }
        hr{
            margin: 0;
            margin-top:4px;
            margin-bottom:4px;

            
            border: 0;
            border-top: var(--bs-border-width) #D9D9D9 solid;
            opacity: 1;
            background: #D9D9D9;
            
        }
        ul{
            list-style-type:none;
            text-align:left;
            padding:0;
            margin:0;

            li{
                transition: all 0.3s ease;
             
                padding: 2px;
                border-radius: ${borderRadius22};
                padding-left: 10px;
                line-height: 26px;
                margin-top: 0;
                &:hover {
                    background: rgba(0,0,0,0.15);
                    cursor: pointer;
                }



                span{
                    transition:all 0.3s ease;
                    margin-left:10px;
                    color:rgba(0,0,0,0.6);
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 300;
                    margin-top: 0;
                    margin-left: 0;
                }
                svg{
                    margin-top:-2px;
                    height: 14px;
                    transition:all 0.3s ease;
                    color:rgba(0,0,0,0.6);
                }

                &:hover{
                    background:rgba(0,0,0,0.15);
                    cursor:pointer;
                    span,
                    svg{
                        color:rgba(0,0,0,1);
                    }
                }
                &.active{
                    color:#3d55d7;
                    span,
                    svg{
                        color:#3d55d7;

                    }
                }
            }
        }
    }

   
    .initTextures{
        span{
            color: rgba(0,0,0,0.6) !important;
            font-family: "Nunito Sans"  !important;
            font-size: 12px  !important;
            font-style: normal  !important; 
            font-weight: 300  !important;
            line-height: normal  !important;
        }

    }


    .dottedLine{
        left: 0px;
        top: 0;
        position: relative;
        height: 20px;
        max-width: 100%;
        overflow: hidden;
        span{
            margin:0 !important;
        }
        span::after{
            float: right;
            width: 105px;
            white-space: nowrap;
            content: ". . . . . . . . . . . . . . . . . . . .";
            color: rgba(0,0,0,0.3);
            position: relative;
            top: -2px;
            left: 10px;
            overflow: hidden;
        }
        span:before{
            top: -2px;
            float: left;
            width: 104px;
            white-space: nowrap;
            content: ". . . . . . . . . . . . . . . . . . . .";
            color: rgba(0,0,0,0.3);
            right: 9px;
            position: relative;
            overflow: hidden;
        }
    }
`;


export const EditorRightActionsBarWindow = styled.div`

  background:white;
  box-shadow: rgb(0 0 0 / 12%) 4px 4px 8px 2px, rgb(0 0 0 / 4%) 0px 0px 0px 3px;


  z-index: 99;
  .commentsWrapepr{
      max-width:100%;
      overflow-x:hidden;
      height: 100%;
      padding:22px;
  }
  h5{
    font-size: 18px !important;
    font-weight: 500 !important;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
    text-align:left;
  }
  
  svg{
    width:20px;
    height: unset;

  }
  .colorPickerScene{
    padding-top: 5px;
    padding-bottom: 5px;
    width: 100%;
    display: block;
    height: 40px;
    img{
      display:none !important;

    }
    span{
      display:none !important;
    }
    .actionButtonHolder{
 
      width:28px !important;
      height:28px !important;

      float:left;
    }
    button{
        border-radius: ${borderRadius22};
      width:28px !important;
      height:28px !important;
      position: relative;

      transition:all 0.1s ease;
      border: 2px solid lightgray;
      left:0 !important;
      float:left;
      
      margin-left:5px;
      &:first-child{
        margin-left:0;
      }

      &.activeButton{

        border: 2px solid #3D55D7;
      }
      
 
      &:hover{

        border: 2px solid rgba(0,0,0,0.15);
      }
    }
  }

    .packageActionsIcons{
      margin-right: 5px;
      margin-left: 5px;
      border-radius: 35px;
        border-radius: ${borderRadius30};
      padding-left: 2px;
      padding-right: 2px;
      padding-top: 3px;
      padding-bottom: 3px;
      margin-bottom: 10px;
      button{
        width: 33%;
        left: 0;
          border-radius: ${borderRadius40};
        font-weight:bold;
        font-size: 15px;
        img{
          height:100%;
          width:fit-content;
          max-height: 35px;
        }
      }

      .mainActionButton{
        &.active{
          box-shadow: rgb(0 0 0 / 5%) 0px 0px 3px 1px, rgb(0 0 0 / 4%) 0px 0px 0px 0px;
          background:white;
          color:black;
        }
        &:hover{
          transform:scale(1);
        }
      }
    }
  .packageActionsIconsSecondLevel{
    padding-bottom: 15px;
    //button{
    //  max-width:50px;
    //}
    span{
      color:black;      
    }


      .hiddenTop{
        display:none;
      }
      .activeLeftAlign{
        display:block;
      }
    
    .actionMenuSecondWrapper{
      text-align: left;
      padding-top: 8px;
      padding-bottom: 8px;
      //padding-left: 15px;
      border-bottom: 1px solid lightgray;
      max-width: 80%;
      margin: auto auto;
      
      .secondButton{
        width: 100%;
          border-radius: ${borderRadius5};
        left: 0;
        padding-top: 10px;
        .secondButtonImage{
          width:20%;
        }
        .secondButtonName{
          width:80%;
          text-align: left;
        }
        >div{
          float:left;
        }
        &:hover{

          background-color: rgb(183 183 183);
          color:black;
          transform:unset;
          span{
            color:black;
          }
          //img{
          //  filter:invert(1);
          //}
        
        }
        &.active{
          background-color: rgb(183 183 183);
          color:black;
          transform:unset;
          span{
            color:black;
          }
        }
        
      }
      img{
        max-height: 20px;
        margin-right:10px;
        //display: block;
        //margin: auto auto;
        //
      }
      span{
        font-weight: bold;
        font-size: 15px;
        -webkit-font-smoothing: antialiased;
      }
    }
.actionMenuThirdWrapper{
  height: fit-content;
  display: block;
  overflow: auto;
  padding-top: 15px;
  &.active{

  }
  &.hiddenDown{
    display:none;
  }
  button:hover{
    background:#c5c5c5;
  }
    .activeButton{
      background:#c5c5c5;
    }
  .actionButtonHolder{
    max-width: 32%;
    overflow: hidden;
    float: left;
    padding: 5px;
    text-align:center;
    button{
      left:0;
        border-radius: ${borderRadius5};
      &:hover{
        transform:unset;
      }
      text-align:center;
      img{
        display: block;
        max-height: 46px;
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }
    &.color_picker{
      img{
        display:none !important;
       
      }
      span{
        display:none !important;
      }
      .actionButtonHolder{
        max-width:unset !important;
        width:15% !important;
        height:30px !important;
      }
      button{
        background: black ;

          border-radius: ${borderRadius25};
        width: 68% ;
        height: 100% ;
        margin: auto auto;
        float: none;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        transition:all 0.1s ease;
        
        &.activeButton,
        &:hover{
          transform: translateX(-50%);
          border: 4px solid #00aaff;
        }
      }
    }
  
}

  }
  &.rightWindowPopup{
    position: absolute;
    top: -110px;
    height: fit-content;
    right: 70px;
    min-width: 200px;
    padding-left: 0;
    padding-right: 0;
    transition:all 0.3s ease;
    padding-bottom: 5px;
    padding-top: 10px;

      border-radius: ${borderRadius22};
    transform:translate3d(500px,0,0);
    opacity:0;
    
    
    //display:none;
    
    h4{
      font-size:18px !important;
      font-weight:800 !important;
      top: 1px;
      margin-bottom: 0 !important;
      padding-bottom: 0 !important;
      position: relative;
      svg{
        height: 20px;
        margin-right: 10px;
        top: 1px;
        position: relative;
      }
      
    }
    .cubeHeader{
      padding-left: 15px;

      height: 25px;

      padding-right: 15px;
    }
    .cubeContent{
      padding-left: 5px;
      padding-right: 5px;
      span{
        color: #7f7f7f;
      }
      .active{
        color:#3D55D7;
        svg,
        span{
          color: #3D55D7;
        }
      }
      span{
        font-weight:500;
      }
      &.off{
        display:none;
      }
    }
    &.active{
      //display:block;
      opacity:1;
      transform:translate3d(0,0,0);
    }


    ul{
      list-style-type: none;
      text-align: left;
      padding: 0;
      margin-bottom: 0;
      margin-top: 0;
      li{
        margin-top:10px;
        transition:all 0.3s ease;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 5px;
        padding-bottom: 5px;
          border-radius: ${borderRadius40};
   span{
     transition:all 0.3s ease;
     font-size:18px;
     
   }
        svg{
       
          margin-right: 10px;
          //max-height:18px;
          font-size:20px;
          color: #7f7f7f;
          transition:all 0.3s ease;
       
        }
        &:hover{
          background: rgba(0,0,0,0.15);
          cursor:pointer;
          svg,
          span{
              color:black;
            cursor:pointer;
            
          }
        }

      }
    }
    &.cubePopup{
      top: -18px;
    }
    &.renderPopup{
      top: 30px;
    }
    &.eyePopup{
      top: 25px;
    }
    .viewOptions{
      div{
        width:33%;
        float:left;
        button{
          width:100%;
          text-align:center;
          svg{
            width: 100%;
            height: 3em;
            margin-bottom: 10px;
          }
          img{
            max-height: 36px;
            display: block;
            margin:auto auto;
            margin-bottom: 11px;
          }
        }
      }
    }
    &.rulerPopup{
      top: 35px;
    }
    .react-switch{
      top: 2px;
    }
    .rulersBox{
      li{
        
      }
    }

      .closeButton{
          height: 30px !important;
          top: -7px !important;
          width:30px;

          min-height: unset !important;
          svg{
              color:#4C4C4C;
              color: #4C4C4C;
              height: 19px;
              left: 50%;
              position: absolute;
              top: 50%;
              transform: translate(-50%, -50%);

              path{
                  fill:#4C4C4C;
              }
          }
          &:hover{
              background:lightgray !important;
          }
      }
    //  
    //
    //.closeButton{
    //  right: -11px;
    //  width: 36px;
    //  height: 36px;
    //  top: -10px;
    //    
    //    svg{
    //        height: 1em;
    //        color: #7f7f7f;
    //        path{
    //            fill: #7f7f7f;
    //        }
    //        
    //    }
    //}
    
    .sceneOptions{
      overflow:auto;
      div{
        overflow:auto;
      }
      .sceneButtonHolder{
        padding:5px;
        float:left;
        max-width: 22%;
      }
      button{
        max-width:100%;
        float:left;
        transition:all 0.3s ease;
          border-radius: ${borderRadius9};
        padding-top: 10px;
        padding-left: 10px;
        padding-right: 10px;
        
        &.activeButton,
        &:hover{
          transform:unset;
          background:#c5c5c5;
        }
      }
    }
  }
  //
    
    &.commentPopup{
        width:300px !important;
        height:500px;
        overflow-y: scroll;
     
        top:50%;
        transform:translateY(-50%) translateX(150%);
        scroll-margin: 130px;
        div{
            scroll-margin: 130px;
        }
        
        .commentHeader{
            h4{
                color: var(--black-70, #4C4C4C) !important;
                /* Editor/Section */
                font-family: "Nunito Sans";
                font-size: 20px !important;
                font-style: normal;
                font-weight: 300 !important;
                line-height: normal;   
                margin-left:15px;
            }
        }
        @media (min-height: 1101px){
            height: 800px;
           
        }
        @media (max-height: 1100px){
            height: 800px;
            
        }

        @media (max-height: 1000px){
            height: 800px;
        
        }
        @media (max-height: 900px){
            height: 700px;
     
        }

        @media (max-height: 800px){
            height: 600px;
         
        }

        @media (max-height: 700px){
            height: 500px;

        }

        @media (max-height: 600px){
            height: 400px;
     
        }
        &.active{
            transform: translate3d(0, -50%, 0) !important;
        }
        
    }

`;

const loadingAnimation = keyframes`
 0% { transform:scale(1); }
 50% {transform:scale(1.5); }
  100% { transform:scale(1); }
`

export const LoadingElement = styled.img`
max-width:50px;
  //transform: translate(-50%, -50%);
  left: 48.7%;
  top: 43%;
position: absolute;
 animation-name: ${loadingAnimation};
 animation-duration: 5s;
 animation-iteration-count: infinite;
`



export const EditorLeftActionsBarWrapper = styled.div`

  top: 50%;
  position: absolute;
  width: 60px;
    left: 8px;
  z-index: 999;
  height: 400px;
  transform: translateY(-50%);
    
    display:none;
    
    &.active{
        display:block;
    }
  
`;


export const EditorSetFrontFaceRotationBottom = styled.div`
    height: 50px;
    bottom: 0;
    
    position: absolute;
    width: 100%;
    left: 0;
    z-index: 9;
  //  background: rgba(0,0,0,0.4);
    text-align: center;
    
    display:none;
    
    &.active{
        display:block;
    }
    
    h1{
        color:white;
    }
    
    button{
        height: 36px !important;
        padding: 5px 36px !important;
    }
    .cancel{
        //background:white !important;
        //color:#3D55D7 !important;
        //border-color:white !important;
        &:hover{
            background:white !important;
            color:black !important;
           // background:#3D55D7 !important;
         //   color: white !important;
        }
    }

    .ok{
        background:white !important;
        color:#3D55D7 !important;
        border-color:white !important;
        &:hover{
            border-color:#3D55D7 !important;
            background:#3D55D7 !important;
            color: white !important;
        }
    }
`;


export const EditorSetFrontFaceRotationLine = styled.div`
    height: 100%;
    top: 0;
    
    position: absolute;
    width: 1px;
    background:red;
    
    left: 50%;
    z-index: 9;
  
    text-align: center;
    
    display:none;
    &.active{
        display:block;
    }
`;

export const EditorSetFrontFaceRotationTop = styled.div`

    top: 28px;
    position: absolute;
    width: 100%;
    left: 0;
    z-index: 9;
    height: 60px;
    //background: rgba(0,0,0,0.4);
    text-align: center;
    
    display:none;
    
    .angleRotation{

        position: absolute;
        right: 50px;
        top: 0;
       
    
        input{
            color: white;
            background: transparent;
        }
    }
    span{
        color:white;
    }
    
    
    &.active{
        display:block;
    }
    
    h1{
        font-family: "Nunito Sans";
        font-size: 22px !important;
        font-style: normal !important;
        font-weight: 300 !important;
        line-height: normal;
        
        color:white;
    }

`;

export const EditorSetFrontFaceRotationLeft = styled.div`

    top: 50%;
    transform:translateY(-50%);
    position: absolute;
    width: 100%;
    left: 23px;
    z-index: 9;
    height: 60px;
    //background: rgba(0,0,0,0.4);
    text-align: center;

    display:none;

    .shrinkProductRotationChooser{
        background:white;
        width: fit-content;
        padding: 7px;
        border-radius: ${borderRadius22};
        box-shadow: 5px 5px 20px 0px rgba(0, 0, 0, 0.20);
        .shrinkRow{
            &:not(:first-child){
                margin-top:6px;   
            }
            gap: 6px;
        }
    }
    .pack4{
        width: 84px;
        height: 84px;
        padding: 4px;
    }
    .pack6{
        width: 84px;
        height: 84px;
        padding: 4px;
    }
    .pack8{
        width: 164px;
        height: 84px;
        padding: 4px;
    }


    .shrinkProduct{
        width: 36px;
        height: 36px;
        border: 2px solid  #999;
        border-radius: ${borderRadius50percent};
        display:inline-block;
        float:left;
        transition:all 0.3s ease;
        &:hover{
            background:#999;
            cursor:pointer;
        }
    }

    .mto-4{
     margin-top:4px;
    }
    .mle-4{
           margin-left:4px;
       }
    
    .angleRotation{

        position: absolute;
        right: 50px;
        top: 0;


        input{
            color: white;
            background: transparent;
        }
    }
    span{
        color:white;
    }


    &.active{
        display:block;
    }

    h1{
        font-family: "Nunito Sans";
        font-size: 22px !important;
        font-style: normal !important;
        font-weight: 300 !important;
        line-height: normal;

        color:white;
    }

`;
